module.exports = __webpack_public_path__ + "static/img/pc-web-img02@w.1bdf5bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lotte-tms/pc-web-img02@w.png
// module id = Ln+T
// module chunks = 0